<template>
  <v-row no-gutters class="fill-height" align="center" justify="center">
    <v-progress-circular :size="60" :width="5" color="primary" indeterminate />
  </v-row>
</template>

<script>
export default {
  name: "loading-component"
};
</script>

<style scoped lang="scss">
@import "Loading.scss";
</style>
